const TEMPLATE_LABELS = {
  Booking: "Booking",
  Reschedule: "Reschedule",
  Cancellation: "Cancel",
  Reminder: "Reminder",
  LocationChange: "Change Location",
};

const SUGGESTIONS = {
  Booking: {
    emailSubject: "Appointment confirmed: {VisitName} | {StudyName}",
    emailBody:
      "Dear {VolunteerName},\n\n" +
      "Thank you for participating in {StudyName}. Your appointment has been confirmed as follows:\n\n" +
      "Visit: {VisitName}\n" +
      "Date: {Date}\n" +
      "Time: {Time}\n" +
      "Location: {AppointmentLocation}\n" +
      "Appointment type: {AppointmentType}\n\n" +
      "Please arrive on time and bring any documents requested by the study team.\n\n" +
      "Kind regards,\n" +
      "{StudyName} Team",
    smsText:
      "{StudyName}: Your {VisitName} appointment is confirmed for {Date} at {Time}. Location: {AppointmentLocation}.",
  },
  Reschedule: {
    emailSubject: "Appointment rescheduled: {VisitName} | {StudyName}",
    emailBody:
      "Dear {VolunteerName},\n\n" +
      "Your appointment for {VisitName} in study {StudyName} has been rescheduled.\n\n" +
      "Updated appointment details:\n" +
      "Date: {Date}\n" +
      "Time: {Time}\n" +
      "Location: {AppointmentLocation}\n\n" +
      "If this time is not convenient, please contact the study team as soon as possible.\n\n" +
      "Kind regards,\n" +
      "{StudyName} Team",
    smsText:
      "{StudyName}: Your {VisitName} appointment has been rescheduled to {Date} at {Time}. Location: {AppointmentLocation}.",
  },
  Cancellation: {
    emailSubject: "Appointment cancelled: {VisitName} | {StudyName}",
    emailBody:
      "Dear {VolunteerName},\n\n" +
      "This is to confirm that your appointment for {VisitName} in study {StudyName} has been cancelled.\n\n" +
      "Cancelled appointment:\n" +
      "Date: {Date}\n" +
      "Time: {Time}\n\n" +
      "If you have any questions or wish to rebook, please contact the study team.\n\n" +
      "Kind regards,\n" +
      "{StudyName} Team",
    smsText:
      "{StudyName}: Your {VisitName} appointment on {Date} at {Time} has been cancelled. Contact us to rebook.",
  },
  Reminder: {
    emailSubject: "Appointment reminder: {VisitName} | {StudyName}",
    emailBody:
      "Dear {VolunteerName},\n\n" +
      "This is a friendly reminder of your upcoming appointment for {VisitName} in study {StudyName}.\n\n" +
      "Appointment details:\n" +
      "Date: {Date}\n" +
      "Time: {Time}\n" +
      "Location: {AppointmentLocation}\n\n" +
      "We look forward to seeing you. Please contact us if you are unable to attend.\n\n" +
      "Kind regards,\n" +
      "{StudyName} Team",
    smsText:
      "Reminder — {StudyName}: {VisitName} on {Date} at {Time}. Location: {AppointmentLocation}.",
  },
  LocationChange: {
    emailSubject: "Appointment location updated: {VisitName} | {StudyName}",
    emailBody:
      "Dear {VolunteerName},\n\n" +
      "The location for your {VisitName} appointment in study {StudyName} has been updated.\n\n" +
      "Appointment details:\n" +
      "Date: {Date}\n" +
      "Time: {Time}\n" +
      "New location: {AppointmentLocation}\n\n" +
      "Please use the updated location when you attend your appointment.\n\n" +
      "Kind regards,\n" +
      "{StudyName} Team",
    smsText:
      "{StudyName}: {VisitName} location updated. {Date} at {Time}. New location: {AppointmentLocation}.",
  },
};

export function getEcommSuggestions(templateType) {
  const key = templateType || "Booking";
  const row = SUGGESTIONS[key] || SUGGESTIONS.Booking;
  const label = TEMPLATE_LABELS[key] || key;
  return { ...row, templateType: key, label };
}
